import { render, staticRenderFns } from "./ClientLogo.vue?vue&type=template&id=5947233b&"
import script from "./ClientLogo.vue?vue&type=script&lang=js&"
export * from "./ClientLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports